// extracted by mini-css-extract-plugin
module.exports = {"item":"DropdownItem-styles_item__1El4H","button":"DropdownItem-styles_button__19-UH","leftIcon":"DropdownItem-styles_leftIcon__39E_l"};